import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Tools = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M2.43933 1.88386L1.56065 2.76254C0.974861 3.34833 0.97486 4.29808 1.56065 4.88387L2.93933 6.26255C3.49446 6.81768 4.37647 6.84673 4.96581 6.34969L6.21966 7.60353L7.28032 6.54287L6.02647 5.28903C6.52351 4.69968 6.49446 3.81768 5.93933 3.26254L4.56065 1.88386C3.97486 1.29808 3.02511 1.29808 2.43933 1.88386ZM3.99999 5.20188L2.62131 3.8232L3.49999 2.94452L4.87867 4.3232L3.99999 5.20188Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M9.99999 4.3232C9.99999 3.21864 10.8954 2.3232 12 2.3232C12.2935 2.3232 12.5722 2.38641 12.8232 2.49996L12 3.3232C11.7238 3.59935 11.7238 4.04706 12 4.3232C12.2761 4.59935 12.7238 4.59935 13 4.32321L13.8232 3.49996C13.9368 3.75103 14 4.02974 14 4.3232C14 5.42777 13.1046 6.3232 12 6.3232C11.7228 6.3232 11.4589 6.26684 11.2189 6.16494L5.84172 11.5421C5.94362 11.7821 5.99999 12.0461 5.99999 12.3232C5.99999 13.4278 5.10456 14.3232 3.99999 14.3232C3.70652 14.3232 3.42781 14.26 3.17674 14.1465L3.99999 13.3232C4.27613 13.0471 4.27613 12.5993 3.99999 12.3232C3.72384 12.0471 3.27613 12.0471 2.99999 12.3232L2.17674 13.1465C2.06319 12.8954 1.99999 12.6167 1.99999 12.3232C1.99999 11.2186 2.89542 10.3232 3.99999 10.3232C4.27712 10.3232 4.54109 10.3796 4.78106 10.4815L10.1583 5.10428C10.0564 4.86431 9.99999 4.60034 9.99999 4.3232Z"
      fill="currentColor"
    />
    <path
      d="M11.1162 14L7.96971 10.8535L9.03037 9.79281L12.0001 12.7626L12.9395 11.8232L9.96971 8.85347L11.0304 7.79281L14.1769 10.9393C14.6651 11.4275 14.6651 12.219 14.1769 12.7071L12.884 14C12.3959 14.4882 11.6044 14.4882 11.1162 14Z"
      fill="currentColor"
    />
  </Icon>
));

export default Tools;
